import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, ArrowRight } from 'lucide-react';
import { useBusiness } from '../contexts/BusinessContext';

export default function Home() {
  const { selectedBusiness } = useBusiness();

  return (
    <div className="flex-1 overflow-auto">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Welcome Message */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <HomeIcon className="h-8 w-8 text-blue-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">
            Welcome {selectedBusiness?.name || 'Nexus'}
          </h1>
        </div>

        {/* Quick Action Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 max-w-md mx-auto">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Set Your Home Screen</h2>
          <p className="text-gray-600 mb-6 text-sm">
            Choose which app you want to see first when you log in. You can change this anytime in Business Settings.
          </p>
          <Link
            to="/settings"
            className="inline-flex items-center justify-center w-full px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium"
          >
            Go to Settings
            <ArrowRight className="h-5 w-5 ml-2" />
          </Link>
        </div>

        {/* Info Note */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            This page appears because you haven't set a default home screen yet
          </p>
        </div>
      </div>
    </div>
  );
}
